@if (isVisible) {
  <div class="loading-overlay">
    <img class="loading-gif" src="/assets/images/loading.gif" alt="loading...">
  </div>
}
